<template>
  <RadioGroup v-model="selected_value" class="mt-2">
    <div :class="`grid grid-cols-${statuses.length} gap-3`">
      <RadioGroupOption
        as="template"
        v-for="status in statuses"
        :key="status.id"
        :value="status.id"
        v-slot="{ active, checked }"
      >
        <div
          :class="[
            'cursor-pointer focus:outline-none',
            active ? 'ring-2 ring-offset-2 ring-' + status.color + '-500' : '',
            checked
              ? 'bg-' +
                status.color +
                '-100 border-transparent text-' +
                status.color +
                '-800 hover:bg-' +
                status.color +
                '-100'
              : 'bg-white border-gray-200 text-gray-900 hover:bg-slate-50',
            'border rounded-md py-1 px-1 flex items-center justify-center text-sm font-medium sm:flex-1',
          ]"
        >
          <RadioGroupLabel as="span">
            {{ status.name }}
          </RadioGroupLabel>
        </div>
      </RadioGroupOption>
    </div>
  </RadioGroup>
</template>

<script>
import { RadioGroup, RadioGroupLabel, RadioGroupOption } from "@headlessui/vue";

export default {
  components: { RadioGroup, RadioGroupLabel, RadioGroupOption },
  props: ["modelValue"],
  data() {
    return {
      selected_value: this.modelValue,
      statuses: [
        { id: 1, name: "No iniciado", color: "gray" },
        { id: 2, name: "Iniciado", color: "yellow" },
        { id: 3, name: "Finalizado", color: "indigo" },
        { id: 4, name: "Cancelado", color: "red" },
      ],
    };
  },
  updated() {
    this.selected_value = this.modelValue;
  },
  watch: {
    selected_value: function (newValue) {
      this.$emit("update:modelValue", newValue);
    },
  },
};
</script>